import React from 'react';
import loaderSvg from '@bbkAdminComponents/experiences/pricing-pages-editors/assets/loader-pricing-page-mockup.svg';
import { cs } from '@bbkAdminUtils/css-utils';

interface PricingPageShimmerLoaderProps {
  className?: string;
  isFullScreen?: boolean;
}

export const PricingPageShimmerLoader: React.FC<
  PricingPageShimmerLoaderProps
> = ({ className, isFullScreen = true }) => {
  return (
    <div
      className={cs(
        'tw-relative tw-flex tw-items-center tw-justify-center tw-bg-transparent',
        isFullScreen ? 'tw-h-screen tw-w-full' : 'tw-h-full tw-w-full',
        className
      )}
    >
      <div
        className={cs(
          'tw-absolute tw-z-50',
          'tw-animate-pulse',
          'tw-bg-opacity-10 tw-bg-contain tw-bg-center tw-bg-no-repeat',
          isFullScreen
            ? 'tw-h-full tw-w-full'
            : 'tw-top-4 tw-h-[600px] tw-w-full tw-max-w-5xl'
        )}
        style={{
          backgroundImage: `url(${loaderSvg})`,
        }}
      />
    </div>
  );
};
